
import { Button } from "@/components/ui/button";
import { Target, Bug } from "lucide-react";

interface EmptyReportsStateProps {
  allReportsCount: number;
  onDebug: () => Promise<void>;
  onEnhancedRefresh: () => Promise<void>;
}

export const EmptyReportsState = ({ 
  allReportsCount, 
  onDebug, 
  onEnhancedRefresh 
}: EmptyReportsStateProps) => {
  return (
    <div className="text-center py-8 text-gray-500">
      <Target size={48} className="mx-auto mb-4 text-gray-300" />
      <p className="text-lg font-medium mb-2">No regional reports found</p>
      <p className="text-sm mb-4">
        Add your location in your profile to get personalized USDA market reports using our enhanced radius-based matching.
      </p>
      <div className="bg-purple-50 border border-purple-200 rounded-lg p-4 mt-4">
        <div className="flex items-start space-x-2">
          <Target size={16} className="text-purple-600 mt-0.5" />
          <div className="text-sm text-purple-800">
            <p className="font-medium mb-1">Enhanced Hierarchical Matching System</p>
            <p className="mb-2">
              Our enhanced system uses a intelligent hierarchy for precise matching:
            </p>
            <ul className="list-disc list-inside space-y-1 text-xs">
              <li><strong>Priority 1:</strong> Geographic radius matching within 60 miles (highest accuracy)</li>
              <li><strong>Priority 2:</strong> State-level matching for broader coverage</li>
              <li><strong>Priority 3:</strong> Regional matching (South U.S., Central U.S., etc.)</li>
              <li><strong>Priority 4:</strong> City/market matching for legacy compatibility</li>
            </ul>
            <p className="mt-2">
              Available reports in database: {allReportsCount}
            </p>
          </div>
        </div>
      </div>
      <div className="flex justify-center space-x-2 mt-4">
        <Button onClick={onDebug} variant="outline">
          <Bug size={16} className="mr-2" />
          Debug Issue
        </Button>
        <Button onClick={onEnhancedRefresh} variant="outline">
          <Target size={16} className="mr-2" />
          Start Enhanced Matching
        </Button>
      </div>
    </div>
  );
};
